import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

function dataURLtoBlob(dataURL) {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export const fetchUserEngagement = createAsyncThunk(
  "userEngagement/fetchUserEngagement",
  async (
    { search, page, rowsPerPage, sort_by, sort_order, dateFilter, role, from, to, users, month, year },
    { rejectWithValue }
  ) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/userlist/user-engagement?search=${search}&page=${
          page + 1
        }&limit=${rowsPerPage}&dateFilter=${
          dateFilter || ""
        }&sort_by=${sort_by}&sort_order=${sort_order}&role=${role}&from=${from}&to=${to}&user=${users}&month=${month || ""}&year=${year || ""}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch userEngagements." }
      );
    }
  }
);
export const fetchMailLog = createAsyncThunk(
  "userEngagement/fetchMailLog",
  async (
    { search, page, rowsPerPage, sort_by, sort_order, role, from, to, users, type, month, year },
    { rejectWithValue }
  ) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/userlist/email-history?search=${search}&page=${
          page + 1
        }&limit=${rowsPerPage}&sort_by=${sort_by}&sort_order=${sort_order}&role=${role}&from=${from}&to=${to}&user=${users}&mailType=${type}&month=${month || ""}&year=${year || ""}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch mail logs." }
      );
    }
  }
);
//   "userEngagement/sendMail",
//   async (datas, { rejectWithValue }) => {
//     const token = getToken();

//     if (!token) {
//       return rejectWithValue({
//         message: "No token found, authorization failed.",
//       });
//     }
    

//     try {
//       const response = await axios.post(
//         `${Apiurl}admin/userlist/trigger-user-mail`,
//         datas,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       Swal.fire({
//         icon: "success",
//         title: "Email!",
//         text: "Email sent successfully",
//         timer: 3000,
//       });

//       return response.data;
//     } catch (error) {
//       // Enhanced error handling
//       const errorMessage =
//         error.response?.data?.message || "Please try again later.";

//       Swal.fire({
//         icon: "error",
//         title: "UserEngagement Failed",
//         text: errorMessage,
//         timer: 3000,
//       });

//       return rejectWithValue(
//         error.response?.data || {
//           message: errorMessage,
//           status: error.response?.status,
//         }
//       );
//     }
//   }
// );

export const sendMail = createAsyncThunk(
  "userEngagement/sendMail",
  async (datas, { rejectWithValue }) => {
    const token = getToken();

    if (!token) {
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });
    }

    try {
      const formData = new FormData();
      
      formData.append('user_ids', JSON.stringify(datas.user_ids));
      formData.append('subject', datas.subject);
      formData.append('message', datas.message);
      
      if (datas.attachments && datas.attachments.length > 0) {
        datas.attachments.forEach((file, index) => {
          if (file instanceof File) {
            formData.append(`attachments[${index}]`, file);
          } 
          else if (file.content && file.content.startsWith('data:')) {
            const blob = dataURLtoBlob(file.content);
            formData.append(`attachments[${index}]`, blob, file.name || `file-${index}`);
          }
        });
      }

      const response = await axios.post(
        `${Apiurl}admin/userlist/trigger-user-mail`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Email!",
        text: "Email sent successfully",
        timer: 3000,
      });

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Please try again later.";

      Swal.fire({
        icon: "error",
        title: "UserEngagement Failed",
        text: errorMessage,
        timer: 3000,
      });

      return rejectWithValue(
        error.response?.data || {
          message: errorMessage,
          status: error.response?.status,
        }
      );
    }
  }
);


const initialState = {
  engagement: [],
  mailLog:[],
  count: 0,
  loading: false,
  status: "idle",
  userEngagementStatus: "idle",
  error: null,
};

const userEngagementSlice = createSlice({
  name: "userEngagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserEngagement.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchUserEngagement.fulfilled, (state, action) => {
        state.engagement = action.payload.data;
        state.count = action.payload.pagination?.total;
        state.status = "succeeded";
      })
      .addCase(fetchUserEngagement.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(fetchMailLog.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchMailLog.fulfilled, (state, action) => {
        state.mailLog = action.payload.data;
        state.count = action.payload?.total;
        state.status = "succeeded";
      })
      .addCase(fetchMailLog.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(sendMail.pending, (state) => {
        state.error = null;
        state.userEngagementStatus = "pending";
      })
      .addCase(sendMail.fulfilled, (state, action) => {
        state.sendMail = action.payload;
        state.userEngagementStatus = "succeeded";
      })
      .addCase(sendMail.rejected, (state, action) => {
        state.error = action.payload;
        state.userEngagementStatus = "failed";
      });
  },
});

export default userEngagementSlice.reducer;
